import { FORM_ELEMENT_KEYS } from './form-element-keys';
// Ancestor keys (single or array) plus the element's own key, as one flat path.
export const elementPath = (classes)=>[
        ...classes.parent ? [
            classes.parent
        ].flat() : [],
        classes.key
    ];
export const FORM_FIELD_LABEL_CLASS = 'form-field-label';
export const FORM_FIELD_REQUIRED_INDICATOR_CLASS = 'form-field-required-indicator';
export const FORM_FIELD_DESCRIPTION_CLASS = 'form-field-description';
export const FORM_FIELD_ERROR_CLASS = 'form-field-error';
export const FORM_FIELD_FILE_UPLOAD = {
    key: FORM_ELEMENT_KEYS.FILE_UPLOAD,
    base: 'form-field-file-upload',
    hover: 'form-field-file-upload--hover'
};
export const FORM_FIELD_FILE_UPLOAD_BUTTON = {
    key: FORM_ELEMENT_KEYS.UPLOAD_BUTTON,
    parent: FORM_ELEMENT_KEYS.FILE_UPLOAD,
    base: 'form-field-file-upload-button',
    hover: 'form-field-file-upload-button--hover'
};
export const FORM_FIELD_FILE_UPLOAD_STATUS_CLASS = 'form-field-file-upload-status';
export const FORM_FIELD_FILE_UPLOAD_BUTTON_ICON_CLASS = 'form-field-file-upload-button-icon';
export const FORM_FIELD_FILE_UPLOAD_BUTTON_LABEL = {
    key: FORM_ELEMENT_KEYS.UPLOAD_BUTTON_LABEL,
    base: 'form-field-file-upload-button-label',
    hover: 'form-field-file-upload-button-label--hover'
};
export const FORM_FIELD_SIGNATURE_DROP_ZONE = {
    key: FORM_ELEMENT_KEYS.SIGNATURE_DROP_ZONE,
    parent: FORM_ELEMENT_KEYS.SIGNATURE,
    base: 'form-field-signature-upload-area',
    hover: 'form-field-signature-upload-area--hover'
};
export const FORM_FIELD_SIGNATURE_TYPING_AREA = {
    key: FORM_ELEMENT_KEYS.SIGNATURE_TYPING_AREA,
    parent: FORM_ELEMENT_KEYS.SIGNATURE,
    base: 'form-field-signature-typing-area',
    hover: 'form-field-signature-typing-area--hover'
};
export const FORM_FIELD_SIGNATURE_UPLOAD_BUTTON = {
    key: FORM_ELEMENT_KEYS.SIGNATURE_UPLOAD_BUTTON,
    parent: [
        FORM_ELEMENT_KEYS.SIGNATURE,
        FORM_ELEMENT_KEYS.SIGNATURE_DROP_ZONE
    ],
    base: 'form-field-signature-upload-area-button',
    hover: 'form-field-signature-upload-area-button--hover'
};
export const FORM_FIELD_SIGNATURE_CLEAR_BUTTON_CLASS = 'form-field-signature-clear-button';
export const FORM_FIELD_SIGNATURE_UPLOAD_BUTTON_ICON_CLASS = 'form-field-signature-upload-area-button-icon';
export const FORM_FIELD_SIGNATURE_UPLOAD_BUTTON_LABEL = {
    key: FORM_ELEMENT_KEYS.UPLOAD_BUTTON_LABEL,
    base: 'form-field-signature-upload-area-button-label',
    hover: 'form-field-signature-upload-area-button-label--hover'
};
export const FORM_FIELD_SIGNATURE_CLASS = 'form-field-signature';
export const FORM_FIELD_SIGNATURE_TAB = {
    key: FORM_ELEMENT_KEYS.SIGNATURE_TAB,
    parent: FORM_ELEMENT_KEYS.SIGNATURE,
    base: 'form-field-signature-mode-tab',
    selected: 'form-field-signature-mode-tab--selected',
    hover: 'form-field-signature-mode-tab--hover'
};
export const FORM_FIELD_SIGNATURE_DRAWING_AREA = {
    key: FORM_ELEMENT_KEYS.SIGNATURE_DRAWING_AREA,
    parent: FORM_ELEMENT_KEYS.SIGNATURE,
    base: 'form-field-signature-drawing-area',
    hover: 'form-field-signature-drawing-area--hover'
};
export const FORM_FIELD_DROPDOWN_POPOVER_CLASS = 'form-field-dropdown-popover';
export const FORM_FIELD_DROPDOWN_TRIGGER = {
    key: FORM_ELEMENT_KEYS.DROPDOWN,
    base: 'form-field-dropdown-trigger',
    hover: 'form-field-dropdown-trigger--hover'
};
export const FORM_FIELD_DATE_INPUT_CLASS = 'form-field-date-input';
export const FORM_FIELD_DATE_INPUT_LABEL_CLASS = 'form-field-date-input-label';
export const FORM_FIELD_MULTILINE_ADDRESS_CLASS = 'form-field-multiline-address';
export const FORM_FIELD_DATE_PICKER = {
    key: FORM_ELEMENT_KEYS.DATE_PICKER,
    base: 'form-field-date-picker',
    hover: 'form-field-date-picker--hover'
};
export const FORM_FIELD_DROPDOWN_POPOVER_OPTION = {
    key: FORM_ELEMENT_KEYS.DROPDOWN_OPTION,
    parent: [
        FORM_ELEMENT_KEYS.DROPDOWN,
        FORM_ELEMENT_KEYS.POPOVER
    ],
    base: 'form-field-dropdown-popover-option',
    selected: 'form-field-dropdown-popover-option--selected',
    hover: 'form-field-dropdown-popover-option--hover'
};
export const FORM_FIELD_SUGGESTION_CLASS = 'form-field-suggestion';
export const FORM_FIELD_FIXED_PAYMENT_CLASS = 'form-field-fixed-payment';
export const FORM_FIELD_RADIO_GROUP_CLASS = 'form-field-radio-group';
export const FORM_FIELD_RADIO_GROUP_OPTION_LABEL_CLASS = 'form-field-radio-group-option-label';
export const FORM_FIELD_RADIO_GROUP_RADIO_BUTTON = {
    key: FORM_ELEMENT_KEYS.RADIO_GROUP_RADIO_BUTTON,
    parent: FORM_ELEMENT_KEYS.RADIO_GROUP,
    base: 'form-field-radio-group-radio-button',
    selected: 'form-field-radio-group-radio-button--selected',
    hover: 'form-field-radio-group-radio-button--hover'
};
export const FORM_FIELD_CHECKBOX_GROUP_CLASS = 'form-field-checkbox-group';
export const FORM_FIELD_CHECKBOX_GROUP_OPTION_LABEL_CLASS = 'form-field-checkbox-group-option-label';
export const FORM_FIELD_CHECKBOX_GROUP_INDICATOR = {
    key: FORM_ELEMENT_KEYS.CHECKBOX_GROUP_INDICATOR,
    parent: FORM_ELEMENT_KEYS.CHECKBOX_GROUP,
    base: 'form-field-checkbox-group-indicator',
    selected: 'form-field-checkbox-group-indicator--selected',
    hover: 'form-field-checkbox-group-indicator--hover'
};
export const FORM_FIELD_CHECKBOX_CLASS = 'form-field-checkbox';
export const FORM_FIELD_CHECKBOX_LABEL_CLASS = 'form-field-checkbox-label';
export const FORM_FIELD_CHECKBOX_INDICATOR = {
    key: FORM_ELEMENT_KEYS.CHECKBOX_INDICATOR,
    parent: FORM_ELEMENT_KEYS.CHECKBOX,
    base: 'form-field-checkbox-indicator',
    selected: 'form-field-checkbox-indicator--selected',
    hover: 'form-field-checkbox-indicator--hover'
};
export const FORM_FIELD_PRODUCT_LIST_CLASS = 'form-field-product-list';
export const FORM_FIELD_PRODUCT_LIST_PRODUCT_NAME_CLASS = 'form-field-product-list-product-name';
export const FORM_FIELD_PRODUCT_LIST_PRICE_CLASS = 'form-field-product-list-price';
export const FORM_FIELD_PRODUCT_LIST_IMAGE_CLASS = 'form-field-product-list-image';
export const FORM_FIELD_PRODUCT_LIST_QUANTITY_CLASS = 'form-field-product-list-quantity';
export const FORM_FIELD_PRODUCT_LIST_INDICATOR = {
    key: FORM_ELEMENT_KEYS.PRODUCT_LIST_INDICATOR,
    parent: FORM_ELEMENT_KEYS.PRODUCT_LIST,
    base: 'form-field-product-list-indicator',
    selected: 'form-field-product-list-indicator--selected',
    hover: 'form-field-product-list-indicator--hover'
};
export const FORM_FIELD_TAGS_CLASS = 'form-field-tags';
export const FORM_FIELD_TAGS_OPTION = {
    key: FORM_ELEMENT_KEYS.TAGS_OPTION,
    parent: FORM_ELEMENT_KEYS.TAGS,
    base: 'form-field-tags-option',
    selected: 'form-field-tags-option--selected',
    hover: 'form-field-tags-option--hover'
};
export const FORM_FIELD_IMAGE_CHOICE_CLASS = 'form-field-image-choice';
export const FORM_FIELD_IMAGE_CHOICE_OPTION = {
    key: FORM_ELEMENT_KEYS.IMAGE_CHOICE_OPTION,
    parent: FORM_ELEMENT_KEYS.IMAGE_CHOICE,
    base: 'form-field-image-choice-option',
    selected: 'form-field-image-choice-option--selected',
    hover: 'form-field-image-choice-option--hover'
};
export const FORM_FIELD_IMAGE_CHOICE_OPTION_IMAGE_CLASS = 'form-field-image-choice-option-image';
export const FORM_FIELD_CHOICE_TAG_CLASS = 'form-field-choice-tag';
export const FORM_FIELD_APPOINTMENT_TIME_SLOT = {
    key: FORM_ELEMENT_KEYS.TIME_SLOT,
    parent: [
        FORM_ELEMENT_KEYS.APPOINTMENT,
        FORM_ELEMENT_KEYS.TIME_SLOTS
    ],
    base: 'form-field-appointment-time-slot',
    selected: 'form-field-appointment-time-slot--selected',
    hover: 'form-field-appointment-time-slot--hover'
};
export const FORM_FIELD_TEXT_INPUT = {
    key: FORM_ELEMENT_KEYS.TEXT_INPUT,
    base: 'form-field-text-input',
    hover: 'form-field-text-input--hover'
};
export const FORM_FIELD_DATE_INPUT_DROPDOWN = {
    key: FORM_ELEMENT_KEYS.DROPDOWN,
    parent: FORM_ELEMENT_KEYS.DATE_INPUT,
    base: 'form-field-date-input-dropdown',
    hover: 'form-field-date-input-dropdown--hover'
};
export const FORM_FIELD_DATE_INPUT_TEXT_INPUT = {
    key: FORM_ELEMENT_KEYS.TEXT_INPUT,
    parent: FORM_ELEMENT_KEYS.DATE_INPUT,
    base: 'form-field-date-input-text-input',
    hover: 'form-field-date-input-text-input--hover'
};
export const FORM_FIELD_DATE_INPUT_POPOVER_CLASS = 'form-field-date-input-popover';
export const FORM_FIELD_DATE_INPUT_POPOVER_OPTION = {
    key: FORM_ELEMENT_KEYS.LIST_OPTION,
    parent: [
        FORM_ELEMENT_KEYS.DATE_INPUT,
        FORM_ELEMENT_KEYS.DROPDOWN,
        FORM_ELEMENT_KEYS.POPOVER
    ],
    base: 'form-field-date-input-popover-option',
    selected: 'form-field-date-input-popover-option--selected',
    hover: 'form-field-date-input-popover-option--hover'
};
export const FORM_FIELD_MULTILINE_ADDRESS_DROPDOWN = {
    key: FORM_ELEMENT_KEYS.DROPDOWN,
    parent: FORM_ELEMENT_KEYS.MULTILINE_ADDRESS,
    base: 'form-field-multiline-address-dropdown',
    hover: 'form-field-multiline-address-dropdown--hover'
};
export const FORM_FIELD_MULTILINE_ADDRESS_TEXT_INPUT = {
    key: FORM_ELEMENT_KEYS.TEXT_INPUT,
    parent: FORM_ELEMENT_KEYS.MULTILINE_ADDRESS,
    base: 'form-field-multiline-address-text-input',
    hover: 'form-field-multiline-address-text-input--hover'
};
export const FORM_FIELD_MULTILINE_ADDRESS_LABEL_CLASS = 'form-field-multiline-address-label';
export const FORM_FIELD_MULTILINE_ADDRESS_POPOVER_CLASS = 'form-field-multiline-address-popover';
export const FORM_FIELD_MULTILINE_ADDRESS_POPOVER_OPTION = {
    key: FORM_ELEMENT_KEYS.LIST_OPTION,
    parent: [
        FORM_ELEMENT_KEYS.MULTILINE_ADDRESS,
        FORM_ELEMENT_KEYS.DROPDOWN,
        FORM_ELEMENT_KEYS.POPOVER
    ],
    base: 'form-field-multiline-address-popover-option',
    selected: 'form-field-multiline-address-popover-option--selected',
    hover: 'form-field-multiline-address-popover-option--hover'
};
export const FORM_FIELD_REPEATER_CLASS = 'form-field-repeater';
export const FORM_FIELD_REPEATER_COUNT = {
    key: FORM_ELEMENT_KEYS.REPEATER_COUNT,
    parent: FORM_ELEMENT_KEYS.REPEATER,
    base: 'form-field-repeater-count',
    hover: 'form-field-repeater-count--hover'
};
export const FORM_FIELD_REPEATER_COUNT_LABEL_CLASS = 'form-field-repeater-count-label';
export const FORM_FIELD_REPEATER_TOGGLE = {
    key: FORM_ELEMENT_KEYS.REPEATER_TOGGLE,
    parent: FORM_ELEMENT_KEYS.REPEATER,
    base: 'form-field-repeater-toggle',
    selected: 'form-field-repeater-toggle--selected',
    hover: 'form-field-repeater-toggle--hover'
};
export const FORM_FIELD_REPEATER_TOGGLE_LABEL_CLASS = 'form-field-repeater-toggle-label';
export const FORM_FIELD_PHONE = {
    key: FORM_ELEMENT_KEYS.PHONE,
    base: 'form-field-phone',
    hover: 'form-field-phone--hover'
};
export const FORM_FIELD_PHONE_POPOVER_CLASS = 'form-field-phone-popover';
export const FORM_FIELD_PHONE_SEARCH = {
    key: FORM_ELEMENT_KEYS.PHONE_SEARCH,
    parent: [
        FORM_ELEMENT_KEYS.PHONE,
        FORM_ELEMENT_KEYS.POPOVER
    ],
    base: 'form-field-phone-search',
    hover: 'form-field-phone-search--hover'
};
export const FORM_FIELD_PHONE_POPOVER_OPTION = {
    key: FORM_ELEMENT_KEYS.PHONE_OPTION,
    parent: [
        FORM_ELEMENT_KEYS.PHONE,
        FORM_ELEMENT_KEYS.POPOVER
    ],
    base: 'form-field-phone-popover-option',
    selected: 'form-field-phone-popover-option--selected',
    hover: 'form-field-phone-popover-option--hover'
};
export const FORM_FIELD_INFO_BANNER_CLASS = 'form-field-info-banner';
export const FORM_FIELD_APPOINTMENT_CLASS = 'form-field-appointment';
export const FORM_FIELD_APPOINTMENT_TIME_SLOTS_CLASS = 'form-field-appointment-time-slots';
export const FORM_FIELD_APPOINTMENT_CALENDAR_CLASS = 'form-field-appointment-calendar';
export const FORM_FIELD_DATE_PICKER_POPOVER_CLASS = 'form-field-date-picker-popover';
export const FORM_FIELD_APPOINTMENT_DATE_TITLE_CLASS = 'form-field-appointment-date-title';
export const FORM_FIELD_APPOINTMENT_INFO_TEXT_CLASS = 'form-field-appointment-info-text';
export const FORM_FIELD_RATINGS_CLASS = 'form-field-ratings';
export const FORM_FIELD_RATING_OPTION = {
    key: FORM_ELEMENT_KEYS.RATING_OPTION,
    parent: FORM_ELEMENT_KEYS.RATINGS,
    base: 'form-field-ratings-option',
    selected: 'form-field-ratings-option--selected',
    hover: 'form-field-ratings-option--hover'
};
export const FORM_FIELD_APPOINTMENT_SHOW_MORE_BUTTON_CLASS = 'form-field-appointment-show-more-button';
export const FORM_FIELD_APPOINTMENT_NOTIFICATION_CLASS = 'form-field-appointment-notification';
export const FORM_FIELD_LINK_CLASS = 'form-field-link';
export const FORM_RICH_CONTENT_CLASS = 'form-rich-content';
export const FORM_SUBMIT_BUTTON = {
    key: FORM_ELEMENT_KEYS.SUBMIT_BUTTON,
    base: 'form-submit-button',
    hover: 'form-submit-button--hover'
};
export const FORM_SUBMIT_BUTTON_LABEL_CLASS = 'form-submit-button-label';
export const ANIMATED_ICON_CLASS = 'animated-icon';
export const FORM_SUBMIT_BUTTON_ICON_CLASS = 'form-submit-button-icon';
export const FORM_NEXT_BUTTON = {
    key: FORM_ELEMENT_KEYS.NEXT_BUTTON,
    base: 'form-next-button',
    hover: 'form-next-button--hover'
};
export const FORM_NEXT_BUTTON_LABEL_CLASS = 'form-next-button-label';
export const FORM_NEXT_BUTTON_ICON_CLASS = 'form-next-button-icon';
export const FORM_PREVIOUS_BUTTON = {
    key: FORM_ELEMENT_KEYS.PREVIOUS_BUTTON,
    base: 'form-previous-button',
    hover: 'form-previous-button--hover'
};
export const FORM_PREVIOUS_BUTTON_LABEL_CLASS = 'form-previous-button-label';
export const FORM_PREVIOUS_BUTTON_ICON_CLASS = 'form-previous-button-icon';
export const FORM_SUCCESS_MESSAGE_CLASS = 'form-success-message';
export const FORM_CLOSED_MESSAGE_CLASS = 'form-closed-message';
export const FORM_ERROR_MESSAGE_CLASS = 'form-error-message';

//# sourceMappingURL=form-element-classes.js.map